import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import LinkIcon from '@mui/icons-material/Link';

export default function ContextMenu({
  open,
  position,
  item,
  selectedCount,
  onClose,
  onOpen,
  onPreview,
  onCodeEdit,
  onDownload,
  onCopyLink,
  onCopyOperationalLink,
  onRename,
  onMove,
  onCopy,
  onDelete,
  isEditable,
}) {
  if (!item) return null;
  const isFolder = item.type === 'folder';
  const multi = selectedCount > 1;

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={position ? { top: position.y, left: position.x } : undefined}
      MenuListProps={{ dense: true }}
    >
      {!multi && isFolder && (
        <MenuItem onClick={() => { onOpen(); onClose(); }}>
          <ListItemIcon><OpenInNewIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Open" secondary="Enter" />
        </MenuItem>
      )}
      {!multi && !isFolder && (
        <MenuItem onClick={() => { onPreview(); onClose(); }}>
          <ListItemIcon><OpenInNewIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Preview" />
        </MenuItem>
      )}
      {!multi && !isFolder && isEditable && (
        <MenuItem onClick={() => { onCodeEdit(); onClose(); }}>
          <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Edit code" />
        </MenuItem>
      )}
      <Divider />
      {!multi && (
        <MenuItem onClick={() => { onDownload(); onClose(); }}>
          <ListItemIcon><DownloadIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={isFolder ? 'Download as ZIP' : 'Download'} />
        </MenuItem>
      )}
      {multi && (
        <MenuItem onClick={() => { onDownload(); onClose(); }}>
          <ListItemIcon><DownloadIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary={`Download ${selectedCount} as ZIP`} />
        </MenuItem>
      )}
      {!multi && !isFolder && (
        <MenuItem onClick={() => { onCopyLink(); onClose(); }}>
          <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Copy public link" />
        </MenuItem>
      )}
      {!multi && !isFolder && (
        <MenuItem onClick={() => { onCopyOperationalLink(); onClose(); }}>
          <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Copy operational link" />
        </MenuItem>
      )}
      <Divider />
      {!multi && (
        <MenuItem onClick={() => { onRename(); onClose(); }}>
          <ListItemIcon><DriveFileRenameOutlineIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Rename" secondary="F2" />
        </MenuItem>
      )}
      <MenuItem onClick={() => { onMove(); onClose(); }}>
        <ListItemIcon><DriveFileMoveIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary={multi ? `Move ${selectedCount} items…` : 'Move…'} />
      </MenuItem>
      {!multi && (
        <MenuItem onClick={() => { onCopy(); onClose(); }}>
          <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Duplicate" />
        </MenuItem>
      )}
      <Divider />
      <MenuItem onClick={() => { onDelete(); onClose(); }} sx={{ color: 'error.main' }}>
        <ListItemIcon sx={{ color: 'error.main' }}><DeleteIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary={multi ? `Delete ${selectedCount} items` : 'Delete'} secondary="Del" />
      </MenuItem>
    </Menu>
  );
}
